import { render, staticRenderFns } from "./MarketingPanel.vue?vue&type=template&id=2face0b5&scoped=true"
import script from "./MarketingPanel.vue?vue&type=script&lang=js"
export * from "./MarketingPanel.vue?vue&type=script&lang=js"
import style0 from "./MarketingPanel.vue?vue&type=style&index=0&id=2face0b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2face0b5",
  null
  
)

export default component.exports